module.exports = __webpack_public_path__ + "img/fraud-1.ac1762d3.jpg";